import React from "react";
import { Formik, Form, Field, ErrorMessage, FormikProps } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button } from "@material-ui/core";

interface FormValues {
  timeFrom: Date | null;
  timeTo: Date | null;
  padding: string;
}

interface Props {
  onSubmit: (values: FormValues) => void;
  isLoading: boolean;
  frequencyPeak: number;
  setSelectedPeak: (peak: string) => void;
}

const initialValues: FormValues = {
  timeFrom: null,
  timeTo: null,
  padding: "",
};

const validationSchema = Yup.object({
  timeFrom: Yup.date().required("Time From is required").nullable(),
  timeTo: Yup.date().required("Time To is required").nullable(),
  padding: Yup.string().required("Padding is required"),
});

const TrendingFftForm: React.FC<Props> = ({
  onSubmit,
  isLoading = false,
  frequencyPeak,
  setSelectedPeak,
}) => {
  const formikRef = React.useRef<FormikProps<FormValues>>(null);

  const handleSubmit = (values: FormValues) => {
    onSubmit(values);
  };

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      innerRef={formikRef}
    >
      {({ errors, touched, setFieldValue }) => (
        <Form className="  d-flex flex-column justify-content-between align-items-center mb-4 trending-form-width  ">
          <h1 className="mb-4 menu-heading text-nowrap ">
            Get Trending FFt Data
          </h1>
          <div className="form-group w-100 ">
            <div className="d-flex justify-content-between">
              <div className="d-flex flex-stack">
                <label className="form-label fw-bolder text-dark fs-6 mb-0">
                  Time From
                </label>
                <div className="required"></div>
              </div>
            </div>
            <div className="pt-3 pb-3  ">
              <Field name="timeFrom">
                {({ field }: any) => (
                  <DatePicker
                    {...field}
                    selected={field.value}
                    wrapperClassName="w-100"
                    onChange={(date) => setFieldValue("timeFrom", date)}
                    showTimeSelect
                    dateFormat="Pp"
                    className="form-control form-control-lg form-control-solid"
                  />
                )}
              </Field>
              {errors.timeFrom && touched.timeFrom ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    <span style={{ color: "red" }} role="alert">
                      {errors.timeFrom}
                    </span>
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          <div className="form-group w-100 ">
            <div className="d-flex justify-content-between">
              <div className="d-flex flex-stack">
                <label className="form-label fw-bolder text-dark fs-6 mb-0">
                  Time To
                </label>
                <div className="required"></div>
              </div>
            </div>
            <div className="pt-3 pb-3  ">
              <Field name="timeTo">
                {({ field }: any) => (
                  <DatePicker
                    {...field}
                    selected={field.value}
                    wrapperClassName="w-100"
                    onChange={(date) => setFieldValue("timeTo", date)}
                    showTimeSelect
                    dateFormat="Pp"
                    className="form-control form-control-lg form-control-solid"
                  />
                )}
              </Field>
              {errors.timeTo && touched.timeTo ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    <span style={{ color: "red" }} role="alert">
                      {errors.timeTo}
                    </span>
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          <div className="form-group w-100 ">
            <div className="d-flex justify-content-between">
              <div className="d-flex flex-stack">
                <label className="form-label fw-bolder text-dark fs-6 mb-0">
                  Padding
                </label>
                <div className="required"></div>
              </div>
            </div>
            <div className="pt-3 pb-3  ">
              <Field
                className="form-control form-control-lg form-control-solid  "
                name="padding"
                type="number"
              />
              {errors.padding && touched.padding ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    <span style={{ color: "red" }} role="alert">
                      {errors.padding}
                    </span>
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          <div className="form-group w-100 ">
            <div className="d-flex justify-content-between">
              <div className="d-flex flex-stack">
                <label className="form-label fw-bolder text-dark fs-6 mb-0">
                  Peak
                </label>
              </div>
            </div>
            <div className="pt-3 pb-3  ">
              <div className="d-flex align-items-center  form-control form-control-lg form-control-solid  ">
                <span>{frequencyPeak + " (Hz)" || "No peak selected"}</span>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3">
            <Button
              type="submit"
              variant="contained"
              className="plotBtn me-2 "
              disabled={isLoading}
            >
              Plot
              {isLoading && (
                <div className="spinner-border ms-2" role="status"></div>
              )}
            </Button>
            <Button
              type="button"
              variant="contained"
              className="plotBtn "
              onClick={() => setSelectedPeak("")}
            >
              Cancel
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default TrendingFftForm;
